import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { db } from '../../firebase/config';
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';
import logger from '../../utils/logger';

const DeleteDialog = ({ open, onClose, files = [], onConfirm, userId, familyCode, collectionPath }) => {
  const handleConfirm = async () => {
    try {
      const recycleBinRef = collection(db, 'recycleBin');
      
      // Move each file to recycle bin
      for (const file of files) {
        const fileRef = doc(db, collectionPath, file.id);
        const fileDoc = await getDoc(fileRef);
        
        if (fileDoc.exists()) {
          await addDoc(recycleBinRef, {
            userId,
            familyCode,
            originalPath: `${collectionPath}/${file.id}`,
            originalData: fileDoc.data(),
            name: file.name,
            deletedAt: new Date().toISOString(),
            fileType: file.type || 'unknown'
          });
        }
      }
      
      // Call the original onConfirm to handle UI updates
      onConfirm(files);
      onClose();
    } catch (error) {
      logger.error('Error moving files to recycle bin:', error);
      // You might want to show an error message to the user here
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      data-testid="delete-dialog"
    >
      <DialogTitle>Move to Recycle Bin</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          The following items will be moved to the recycle bin:
        </Typography>
        <List>
          {files.map((file, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                <DeleteIcon />
              </ListItemIcon>
              <ListItemText primary={file.name || (typeof file === 'string' ? file : `File ${file.id || 'Unknown'}`)} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="error" variant="contained">
          Move to Recycle Bin
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog; 